export default "__VITE_ASSET__C88QfuOZ__"